export default "__VITE_ASSET__BhkaSWgj__"